module.exports = __webpack_public_path__ + "img/play.3504f891.gif";